import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

// import { HashLink as Link } from "react-router-hash-link";
import Forms from "../Forms/Forms";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { deleteStorage } from "../../storage/helper";
import { clearAll } from "../../db/helper";
import {
  publicationsDb,
  courseDb,
  academicPositionsDb,
  awardsDb,
  currentStudentDb,
  educationDb,
  formerStudentsDb,
  profileDb,
  researchFundingDb,
  researchInterestDb,
  editorialAppointmentsDb,
} from "../../db/dbClasses";

import structure from "../../db/structure.json";

import {
  PublicationsForm,
  CoursesForm,
  CurrentStudentsForm,
  EducationForm,
  FormerStudentForm,
  ResearchFundingForm,
  ResearchInterestForm,
  AwardForm,
  AcademicPositionForm,
  EditorialAppointmentsForm,
} from "../Forms/allForms";

import Profile from "../Forms/Profile";
import InstructionsImage from "../../assets/img/instructions.png";

async function seed() {
  const data = structure;
  try {
    await profileDb.create(data.profile);
    await Promise.allSettled([
      ...data.research_funding.map((elem) =>
        researchFundingDb.create({ ...elem })
      ),
      ...data.courses.map((elem) => courseDb.create({ ...elem })),
      ...data.former_students.map((elem) =>
        formerStudentsDb.create({ ...elem })
      ),
      ...data.current_students.map((elem) =>
        currentStudentDb.create({ ...elem })
      ),
      ...data.research_interests.map((elem) =>
        researchInterestDb.create({ ...elem })
      ),
      ...data.publications.map((elem) => publicationsDb.create({ ...elem })),
      ...data.degrees.map((elem) => educationDb.create({ ...elem })),
      ...data.awards.map((elem) => awardsDb.create({ ...elem })),
      ...data.academic_positions.map((elem) =>
        academicPositionsDb.create({ ...elem })
      ),
      ...data.editorial_appointments.map((elem) =>
        editorialAppointmentsDb.create({ ...elem })
      ),
    ]);
    window.location.reload();
    return true;
  } catch (err) {
    return false;
  }
}

async function clearDb() {
  try {
    await clearAll();
    window.location.reload();
    return true;
  } catch (err) {
    return false;
  }
}

async function clearStorage() {
  try {
    await deleteStorage();
    console.log("done deleting!");
    window.location.reload();
    return true;
  } catch (err) {
    return false;
  }
}

function _confirm(callback, action, title) {
  if (window.confirm(`Are you sure about ${action} ${title}?`)) {
    callback();
  }
}

const Admin = ({ logout, user }) => {
  const { path } = useRouteMatch();

  const alertOptions = {
    timeout: 5000,
    position: positions.BOTTOM_CENTER,
  };

  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  if (
    user &&
    user.email !== process.env.REACT_APP_FIREBASE_MAIN_USER_EMAIL &&
    user.email !== process.env.REACT_APP_FIREBASE_DEVELOPER_EMAIL &&
    user.email !== process.env.REACT_APP_FIREBASE_DEVELOPER1_EMAIL
  ) {
    logout();
  }

  return (
    <AlertProvider template={AlertTemplate} {...alertOptions}>
      <div>
        <nav className="navbar navbar-expand-md navbar-dark bg-dark text-white">
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={() => toggleOpen()}
            style={{
              border: "none",
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            style={{
              marginRight: "20px",
            }}
          >
            <Link to="/" className="navbar-brand nav-link">
              Home
            </Link>
          </div>

          <Collapse in={open}>
            <div className="navbar-collapse">
              <ul className="navbar-nav">
                <li className="nav-item active">
                  <Link className="nav-link" to={`/admin`}>
                    Forms
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href={process.env.REACT_APP_FIREBASE_PROJECT_HOMEPAGE}
                  >
                    Settings
                  </a>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link btn btn-danger text-white"
                    onClick={() => logout()}
                  >
                    Sign Out
                  </button>
                </li>
              </ul>
            </div>
          </Collapse>
        </nav>
        <div className="p-5 w-100">
          <Row>
            <Col lg={6}>
              <h1 className="font-open-sans">Welcome, {user?.email}</h1>
              {process.env.NODE_ENV === "development" && (
                <Card>
                  <Card.Header as={"h4"}>
                    Database and Storage controls.
                  </Card.Header>
                  <Card.Body className="d-flex align-items-center justify-content-around">
                    <Button
                      variant="primary"
                      onClick={() => _confirm(seed, "seeding", "Database")}
                    >
                      Seed <br /> Database
                    </Button>

                    <Button
                      variant="danger"
                      onClick={() => _confirm(clearDb, "deleting", "Database")}
                    >
                      Clear
                      <br /> Database
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() =>
                        _confirm(clearStorage, "deleting", "Storage")
                      }
                    >
                      Clear
                      <br /> Storage
                    </Button>
                  </Card.Body>
                </Card>
              )}
            </Col>
            <Col lg={6}>
              <Switch>
                <Route path={`${path}/forms`}>
                  <Forms />
                </Route>
                <Route path={`${path}*`}>
                  <Forms />
                </Route>
              </Switch>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="py-5">
              <Card>
                <Card.Header as={"h2"}>Instructions</Card.Header>
                <Card.Body>
                  <Image src={InstructionsImage} fluid />
                </Card.Body>
              </Card>
              <div id="profile">
                <Profile />
              </div>
              <hr />
              <h1>Education</h1>
              <div id="education" className="mt-5">
                <EducationForm />
              </div>
              <hr />
              <h1>Courses</h1>
              <div id="courses" className="mt-5">
                <CoursesForm />
              </div>
              <hr />
              <h1>Publications</h1>
              <div id="publications" className="mt-5">
                <PublicationsForm />
              </div>
              <hr />
              <h1>Research Interests</h1>
              <div id="researchInterests" className="mt-5">
                <ResearchInterestForm />
              </div>
              <hr />
              <h1>Research Funding</h1>
              <div id="researchFunding" className="mt-5">
                <ResearchFundingForm />
              </div>
              <hr />
              <h1>Editorial Appointments</h1>
              <div id="editorialAppointments" className="mt-5">
                <EditorialAppointmentsForm />
              </div>
              <hr />
              <h1>Current Students </h1>
              <div id="currentStudents" className="mt-5">
                <CurrentStudentsForm />
              </div>
              <hr />
              <h1>Former Students </h1>
              <div id="formerStudents" className="mt-5">
                <FormerStudentForm />
              </div>
              <hr />
              <h1>Awards</h1>
              <div id="award" className="mt-5">
                <AwardForm />
              </div>
              <hr />
              <h1>Academic Positions</h1>
              <div id="academicPositions" className="mt-5">
                <AcademicPositionForm />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </AlertProvider>
  );
};

export default Admin;
